(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-native-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nova-native-carousel')){customElements.define('nova-native-carousel',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};this.track=this.querySelector('.np-track');this.slides=[...this.querySelectorAll('.np-slide')];this.dots=[...this.querySelectorAll('.np-dot')];this.index=0;this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.step)this.go(this.index+Number(button.dataset.step));if(button.dataset.index)this.go(Number(button.dataset.index));},options);this.track.addEventListener('scroll',()=>{const start=this.slides[0]?.offsetLeft||0;this.index=this.slides.reduce((best,slide,index)=>Math.abs(slide.offsetLeft-start-this.track.scrollLeft)<Math.abs(this.slides[best].offsetLeft-start-this.track.scrollLeft)?index:best,0);this.dots.forEach((dot,index)=>dot.setAttribute('aria-pressed',String(index===this.index)));},options);this.track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1));}},options);this.addEventListener('shopify:block:select',event=>{const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);if(index>=0)this.go(index);},options);}disconnectedCallback(){this.abort?.abort();}go(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.slides[this.index].offsetLeft-this.slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}});}

  } catch(e) { console.error(e); }
})();
})();
